import styled from '@emotion/styled';
import {sizes} from 'patient-ping-remedy/packages/theme';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';

export const EmptyLogs = styled(StandardTypography)`
  text-align: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xSmall};
  padding: ${sizes.medium};
  min-height: 0;
  overflow-y: auto;
`;
